import { SxProps } from "@mui/material";

export const sxTextHomeBanner: SxProps = {
  fontFamily: "Montserrat-Regular",
  maxWidth: "485px",
  '@media(max-width: 1280px)': {
    maxWidth: "unset"
  }
};
